








































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import {
  DrivewealthAccountManagementType
} from "@/shared/types";
import Questionnaire from "@/shared/components/investments/drivewealth/Questionnaire.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InvestmentHeaderWithLogo from "@/shared/components/investments/drivewealth/InvestmentHeaderWithLogo.vue";
import * as RouteNames from "@/employee/route-names";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  computed: {
    DrivewealthAccountManagementType () {
      return DrivewealthAccountManagementType;
    }
  },
  components: {
    Questionnaire,
    RiskDisclaimer,
    GenericLoadingSpinner,
    InvestmentHeaderWithLogo
  }
})
export default class QuestionnairePage extends Vue {
  drivewealthStore = useDrivewealthStore();
  @Prop() accountId: number;

  mounted () {
    if (this.accountId) {
      this.drivewealthStore.getAccountSummaryV2({ username: null, partnerId: null, dwAccountId: this.accountId });
    }
  }

  get currentPortfolioId () {
    const accountSummary = this.drivewealthStore.accountSummaryById(this.accountId);

    return accountSummary.portfolioId;
  }

  get isLoaded () {
    return this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }

  get investmentLanding () {
    return RouteNames.InvestmentAccountInfo;
  }
}
